import { useState } from 'react'
import type { DiffFieldChange } from '~/api/types'
import { Badge } from '~/components/ui/badge'
import { cn } from '~/lib/utils'
import { FIELD_LABELS, LONG_FIELDS, SCORING_FIELDS } from './constants'

// 항목의 한 필드 변경 행(from → to). 긴 필드는 기본 접고, 채점 반영 필드는 배지로 강조한다.
export function DiffRow({
    field,
    change,
}: {
    field: string
    change: DiffFieldChange
}) {
    const isLong = LONG_FIELDS.has(field)
    const isScoring = SCORING_FIELDS.has(field)
    const [open, setOpen] = useState(!isLong)
    const label = FIELD_LABELS[field] ?? field

    return (
        <div className='border-border rounded-[var(--radius)] border p-3'>
            <div className='mb-1.5 flex items-center gap-2'>
                <span className='text-foreground text-xs font-bold'>
                    {label}
                </span>
                {isScoring ? <Badge tone='danger'>채점 반영</Badge> : null}
                {isLong ? (
                    <button
                        type='button'
                        onClick={() => setOpen((o) => !o)}
                        className='text-primary ml-auto text-xs font-bold'>
                        {open ? '접기' : '펼치기'}
                    </button>
                ) : null}
            </div>
            {open ? (
                <div
                    className={cn(
                        'gap-2 text-sm',
                        isLong ? 'flex flex-col' : 'flex flex-wrap items-center'
                    )}>
                    <DiffValue value={change.from} kind='from' />
                    <span className='text-muted-foreground shrink-0 text-xs'>
                        →
                    </span>
                    <DiffValue value={change.to} kind='to' />
                </div>
            ) : (
                <p className='text-muted-foreground text-xs'>
                    펼쳐서 변경 내용을 확인하세요.
                </p>
            )}
        </div>
    )
}

function DiffValue({
    value,
    kind,
}: {
    value: string | number | boolean | null
    kind: 'from' | 'to'
}) {
    const text =
        value === null || value === ''
            ? '(없음)'
            : typeof value === 'boolean'
              ? value
                  ? '예'
                  : '아니오'
              : String(value)
    return (
        <span
            className={cn(
                'rounded-[var(--radius)] px-2 py-1 text-sm break-words whitespace-pre-wrap',
                kind === 'from'
                    ? 'bg-muted text-muted-foreground line-through'
                    : 'bg-success-subtle text-success font-bold'
            )}>
            {text}
        </span>
    )
}
